import HttpService from '@/services/http/http.service';


export default class GcpService {
	constructor() {
		this.http = new HttpService();
	}

	getZones() {
		return this.http.get('gcp/zones');
	}

	getImages() {
		return this.http.get('gcp/images');
	}

	getMachineTypes(zone) {
		return this.http.get(`gcp/machine-types/${zone}`);
	}

	getDiskTypes(zone) {
		return this.http.get(`gcp/disk-types/${zone}`);
	}

	updateZones() {
		return this.http.post('gcp/zones');
	}

	updateImages() {
		return this.http.post('gcp/images');
	}

	updateMachineTypes() {
		return this.http.post('gcp/machine-types');
	}

	updateDiskTypes() {
		return this.http.post('gcp/disk-types');
	}

	getInstances() {
		return this.http.get('gcp/instances');
	}

	start(name, zone) {
		return this.http.patch(`gcp/instances/${name}/${zone}/start`)
	}

	stop(name, zone) {
		return this.http.patch(`gcp/instances/${name}/${zone}/stop`)
	}

	reset(name, zone) {
		return this.http.patch(`gcp/instances/${name}/${zone}/reset`)
	}

	status(name, zone) {
		return this.http.get(`gcp/instances/${name}/${zone}/status`)
	}

	ip(name, zone) {
		return this.http.get(`gcp/instances/${name}/${zone}/ip`)
	}
}
